declare global {
    interface Navigator {
        readonly userAgentData?: {
            brands: { brand: string; version: string }[];
        };
    }
}

export function isChromiumBrowser(): boolean {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
        return false;
    }

    if (navigator.userAgentData && Array.isArray(navigator.userAgentData.brands)) {
        return navigator.userAgentData.brands.some(b => b.brand === 'Chromium');
    }

    const isChromeInUA = /Chrome/.test(navigator.userAgent);
    const isLegacyEdge = /Edge\//.test(navigator.userAgent);
    const hasWindowChrome = 'chrome' in window;

    return hasWindowChrome && isChromeInUA && !isLegacyEdge;
}
